import { environment } from "src/environments/environment";
import axios from "axios";
import { requestNavigatorSignOut } from "src/helpers/NavigatorSessionBridge";

const Axios = axios.create({
  baseURL: environment.baseURL
});

Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token)
    config.headers.Authorization = token;
  return config;
})

// Session tokens now expire and can be revoked server-side; on a 401 clear the token
// and send the user back to login instead of leaving them on a silently broken page.
Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error && error.response && error.response.status === 401) {
      await requestNavigatorSignOut();
      localStorage.clear();
      sessionStorage.clear();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
)

export const LoginApi = (data) => {
  return Axios.post(`/users/login`, { data });
};

export const SignupAPi = (data) => {
  return Axios.post(`/users/signup`, { data });
};

export const ForgotPasswordApi = (data) => {
  return Axios.post(`/users/forgotPassword`, { data });
};

export const VerifyOtpApi = (data) => {
  return Axios.post(`/users/verifyOtp`, { data });
};

export const ResetPasswordApi = (data) => {
  return Axios.post(`/users/resetPassword`, { data });
};


// Patients api
export const GetPatientsSummaryAuthHistory = (page, pageSize, columnFilter, searchFilterObj, sortFilter) => {
  return Axios.post(`/patients/summary_auth_history`,
    {}, { params: { page, pageSize, columnFilter, searchFilterObj, sortFilter } });
};

export const GetPatientsHistory = (page, pageSize, columnFilter, searchFilterObj, sortFilter) => {
  return Axios.post(`/patients/patients_history`,
    {}, { params: { page, pageSize, columnFilter, searchFilterObj, sortFilter } });
};

export const GetPatientsAppealHistory = (page, pageSize, columnFilter, searchFilterObj, sortFilter) => {
  return Axios.post(`/patients/appeal_history`,
    {}, { params: { page, pageSize, columnFilter, searchFilterObj, sortFilter } });
};

export const UpdateAuthSummary = (data, patientLog) => {
  return Axios.post(`/patients/update_auth_summary`, { data, patientLog })
}

export const DeleteAuthSummary = (data) => {
  return Axios.post(`/patients/deleteAuth`, {
    data,
  });
};

export const CreateContactActivity = (data, patientLog) => {
  return Axios.post(`/patients/contact_activities`, { data, patientLog });
};

export const UpdateContactActivity = (data, patientLog) => {
  return Axios.put(`/patients/contact_activities`, { data, patientLog });
};

export const DeleteContactActivity = (data) => {
  return Axios.post(`/patients/contact_activities/delete`, { data });
};

export const GetContactActivityHistory = (page, pageSize, sortFilter) => {
  return Axios.post(`/patients/contact_activity_history`, {}, {
    params: { page, pageSize, sortFilter: sortFilter ? JSON.stringify(sortFilter) : undefined },
  });
};

export const SavePatientsData = (data) => {
  return Axios.post(`/patients/save_patient_details`, {
    data,
  });
};

export const getPatientsData = (page, pageSize, columnFilter, searchFilterObj, sortFilter) => {
  return Axios.post(`/patients/get_patient_details`,
    {}, { params: { page, pageSize, columnFilter, searchFilterObj, sortFilter } });
};

// EMR ID mapping  verify against CentralReach, then persist
export const VerifyPatientEmrId = (emrPatientId) => {
  return Axios.post(`/patients/emr_mappings/verify`, { data: { emrPatientId } });
};

export const UpdatePatientEmrId = (data) => {
  return Axios.post(`/patients/emr_mappings/update`, { data });
};

//TODO: This is only getting one patient. This needs to change so it doesn't cause confusion in future
export const GetPatientsDataByID = (data) => {
  return Axios.post(`/patients/get_patients_byid/${data.id}`, {
    data,
  });
};

export const GetPatientsDataFaciclityId = (data) => {
  return Axios.post(`/patients/get_patients_by_facility/${data.facilityId}`, {
    data,
  });
};

export const GetAllPatientIds = (search = '') => {
  return Axios.post(`/patients/get_all_patient_ids`, {}, {
    params: { search }
  });
};

export const UpdatePatientsData = (data) => {
  return Axios.post(`/patients/edit_patient_details`, {
    data,
  });
};

export const DeletePatient = (data) => {
  return Axios.post(`/patients/delete`, {
    data,
  });
};

// email trigger api

export const SendTwilioEmail = (data) => {
  return Axios.post(`/send_email`, {
    data,
  });
};

// messages trigger api

export const SendTwilioSms = (data) => {
  return Axios.post(`/send_msg`, {
    data,
  });
};

// User api

export const UsersData = (data) => {
  return Axios.post(`/users/get_all_users`, {
    data,
  });
};

export const InactiveUsersData = (data) => {
  return Axios.post(`/users/get_inactive_users`, {
    data,
  });
};

export const SSOLoginApi = (data) => {
  return Axios.post(`/users/sso_login`, {
    data,
  });
}

export const DeleteUser = (data) => {
  return Axios.post(`/users/delete`, {
    data,
  });
};

export const StartNavigatorExchangeApi = (returnTo, navigatorState) => (
  Axios.post('/navigator-auth/start', { returnTo, navigatorState })
);

export const ReactivateUser = (data) => {
  return Axios.post(`/users/reactivate`, {
    data,
  });
};

export const GetUSerByDataByID = (data) => {
  return Axios.post(`/users/get_user_by_id/${data.uuid}`, {
    data,
  });
};

export const UpdateUSerData = (data) => {
  return Axios.post(`/users/update_user_data`, {
    data,
  });
};

// Patients Logs api

export const PatientsFromLogs = (data, page, pageSize, columnFilter, searchFilterObj, sortFilter) => {
  return Axios.post(`/patients/logs/${data.patient_id}`, {
    data,
  }, { params: { page, pageSize, columnFilter, searchFilterObj, sortFilter } });
};

export const AllPatientsLogs = (page, pageSize, columnFilter, searchFilterObj, sortFilter) => {
  return Axios.post(`/patients/logs/all`, {},
    { params: { page, pageSize, columnFilter, searchFilterObj, sortFilter } });
};
//Calling API
export const LoginRingCentral = (data) => {
  return Axios.post(`/patients/calls/login`,
    { data });
};

//Calling API
export const CallPatient = (phoneNumber, email) => {
  return Axios.post(`/patients/calls/ring-out`,
    { data: { phoneToCall: phoneNumber, email: email } });
};


// Calender api

export const getClinicalDirectorsFromLocation = (data) => {
  return Axios.post(`/users/clinical_directors`, {
    data,
  });
};

// triggers notifications api call for Slack & MS Teams
export const sendIntakeAuthsMessage = (data, notification) => {
  return Axios.post(`/triggers/intakeAuthsMessage`, {
    data,
  }, { params: { notification } });
};

export const sendInsuranceVerificationMessage = (data, todoListName) => {
  return Axios.post(`/triggers/insuranceVerificationMessage`, {
    data,
  }, { params: { todoListName } });
};

export const sendAssessmentVisitMessage = (data, notification) => {
  return Axios.post(`/triggers/assessmentVisitMessage`, {
    data
  }, { params: { notification } });
};

export const scheduleAssessmentVisitMessage = (data, notification) => {
  return Axios.post(`/triggers/scheduleAssessmentVisitMessage`, {
    data
  }, { params: { notification } });
};

export const sendClinicVisitMessage = (data, notification) => {
  return Axios.post(`/triggers/clinicVisitMessage`, {
    data,
  }, { params: { notification } });
};

// make delegate and events logs
export const sendEventLog = (userData, eventData) => {
  return Axios.post(`/events/log`, {
    userData, eventData
  });
};

export const createMailEvent = (data, attendee) => {
  return Axios.post(`/mailgun/send_event`, {
    data, attendee
  });
};


export const CheckEligibity = (data, token) => {
  return Axios.post(`/healthcare/hcCheckEligibity`, {
    data, config: {
      'Authorization': token
    },
  });
};

export const generateToken = () => {
  return Axios.post(`healthcare/generateToken`);
}

export const getGithubCards = () => {
  return Axios.post(`github/getCards`);
}

export const createGithubCards = (data) => {
  return Axios.post(`github/createCards`, { data });
}

export const getGithubIssues = (data) => {
  return Axios.post(`github/getIssues`, { data });
}

export const getGithubSearchIssues = (data) => {
  return Axios.post(`github/searchIssues`, { data });
}

export const createGithubIssues = (data) => {
  return Axios.post(`github/createIssue`, { data });
}

// user Notificaitons api
export const GetAllUserNotifications = () => {
  return Axios.post(`user_notification/get_user_notifications`);
}
export const GetCountNotifications = () => {
  return Axios.post(`user_notification/get_count_notifications`);
}

export const UpdateNotifications = () => {
  return Axios.post(`user_notification/update_notifications`);
}
export const UpdateNotification = (data) => {
  return Axios.post(`user_notification/update_notification`, {
    data,
  });
};


// location api
export const GetLocations = () => {
  return Axios.post(`locations/getLocations`);
}

export const GetAllLocations = () => {
  return Axios.post(`locations/getAllLocations`);
}

export const SaveLocation = (data) => {
  return Axios.post(`locations/saveLocation`, {
    data,
  });
}

export const UpdateLocation = (data) => {
  return Axios.post(`locations/updateLocation`, {
    data,
  });
}

// pending status api
export const GetPendingStatuses = () => {
  return Axios.post(`pendingStatus/getPendingStatuses`);
}

export const GetAllPendingStatuses = () => {
  return Axios.post(`pendingStatus/getAllPendingStatuses`);
}

export const SavePendingStatus = (data) => {
  return Axios.post(`pendingStatus/savePendingStatus`, {
    data,
  });
}

export const updatePendingStatus = (data) => {
  return Axios.post(`pendingStatus/updatePendingStatus`, {
    data,
  });
}

// payors api
export const GetPayors = () => {
  return Axios.post(`payors/getPayors`);
}

export const SavePayor = (data) => {
  return Axios.post(`payors/savePayor`, {
    data,
  });
}

export const updatePayor = (data) => {
  return Axios.post(`payors/updatePayor`, {
    data,
  });
}

// resources api
export const GetResources = () => {
  return Axios.post(`resources/getResources`);
}
export const DeleteResource = (fileName) => {
  return Axios.delete(`resources/deleteFile/${fileName}`)
}

export const DownloadResource = (fileName) => {
  return Axios.post(`resources/download/${fileName}`, {
    responseType: 'blob'
  });
}

export const UploadResources = (data) => {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('name', data.name);

  const userEmail = localStorage.getItem('userEmail');
  formData.append('email', userEmail)
  return Axios.post('/resources/uploadResources', formData, {
    headers: {
      // Authorization is set by the request interceptor from the real stored token.
      'Content-Type': 'multipart/form-data'
    }
  });
}


// lookup api
export const GetFacilities = () => {
  return Axios.post(`lookup/facilities`);
}

export const GetActiveFacilities = () => {
  return Axios.post(`lookup/activeFacilities`);
}

export const UpdateFacilityStatus = (data) => {
  return Axios.post(`lookup/updateFacilityStatus`, {
    data,
  });
}

export const UpdateFacilityRelationship = (data) => {
  return Axios.post(`lookup/updateFacilityRelationship`, {
    data,
  });
}

export const GetAllLookups = () => {
  return Axios.post(`lookup/lookups`);
}


// referral api
export const GetReferral = (id) => {
  return Axios.post(`referral/getReferrals/${id}`);
}

export const SaveReferral = (data) => {
  return Axios.post(`referral/saveReferral`, {
    data,
  });
}

export const GetFacilitiesOverview = () => {
  return Axios.post(`referral/getFacilitiesOverview`);
}

export const GetFacilityCities = () => {
  return Axios.post(`referral/getFacilityCities`);
}

export const UpdateReferral = (id, data) => {
  return Axios.post(`referral/updateReferral`, {
    id,
    data,
  });
}

export const DeleteReferral = (id) => {
  return Axios.post(`referral/deleteReferral`, {
    id,
  });
}

// workflow api
export const getUserWorkflowWithTasks = (userId) => {
  return Axios.post(`workflow/getUserWorkflowWithTasks/${userId}`);
}

export const SaveWorkflow = (data) => {
  return Axios.post(`workflow/saveWorkflow`, {
    data,
  });
}

export const UpdateTaskNotes = (data) => {
  return Axios.post(`workflow/updateTaskNotes`, {
    data,
  });
}

export const ChangeTaskStatus = (data) => {
  return Axios.post(`workflow/changeTaskStatus`, {
    data,
  });
}

export const SaveTasks = (data) => {
  return Axios.post(`workflow/saveTasks`, {
    data,
  });
}

export const ChangeWorkflowStatus = (data) => {
  return Axios.post(`workflow/changeWorkflowStatus`, {
    data,
  });
}
export const ReassignUser = (data) => {
  return Axios.post(`workflow/reassignUser`, {
    data,
  });
}

export const UpdateTaskPriority = (data) => {
  return Axios.post(`workflow/updateTaskPriority`, {
    data,
  });
}

export const ManualTriggerWorkflows = () => {
  return Axios.post('workflow/manualTriggers')
}

// Predefined Tasks API
export const TriggerPredefinedTask = (data) => {
  return Axios.post('predefineTasks/create-predefine-task', {
    data,
  });
}

export const GetAllPredefineTasks = (data) => {
  return Axios.post('predefineTasks/get-all-predefine-tasks', {
    data,
  });
}

export const UpdatePredefinedTaskStatus = (data) => {
  return Axios.post('predefineTasks/update-predefine-task-status', {
    data,
  });
}

export const ReassignPredefinedTask = (data) => {
  return Axios.post('predefineTasks/reassign-predefine-task', {
    data,
  });
}

export const UpdatePredefinedTaskNotes = (data) => {
  return Axios.post('predefineTasks/update-predefine-task-notes', {
    data,
  });
}

export const UpdatePredefinedTaskDueDate = (data) => {
  return Axios.post('predefineTasks/update-predefine-task-due-date', {
    data,
  });
}

export const UpdatePatientDocumentFolders = (data) => {
  return Axios.post('predefineTasks/update-patient-document-folders', {
    data,
  });
}

export const UpdatePredefinedTaskPriority = (data) => {
  return Axios.post('predefineTasks/update-priority', {
    data,
  });
}

export const GetEligibleUsersForTask = (taskId) => {
  return Axios.post('predefineTasks/get-eligible-users', {}, {
    params: { taskId }
  });
}

// Event Tracking API
export const createEvent = (data) => {
  return Axios.post('events/create-event', {
    data,
  });
}

export const cancelEvent = (cancellationReason, patientId, scheduledDate, eventType, cancellationLocationId, cancelledByUserId) => {
  return Axios.post(`events/cancel-event`, {
    cancellationReason,
    patientId,
    scheduledDate,
    eventType,
    cancellationLocationId,
    cancelledByUserId
  });
}

// Reminder API
export const createReminder = (data) => {
  return Axios.post('/reminder/createReminder', data);
};

export const updateReminder = (id, data) => {
  return Axios.put(`/reminder/updateReminder/${id}`, data);
};

export const deleteReminder = (id) => {
  return Axios.delete(`/reminder/deleteReminder/${id}`);
};

export const getUserReminders = (facilityId) => {
  const userId = localStorage.getItem('userId');
  return Axios.post('/reminder/getUserReminders', { data: { userId, facilityId } });
};

// Staff review stays in Pathway; the server owns integration credentials.
export const RecheckPatientTransfer = (patientId, candidateId, input) =>
  Axios.post(`/patients/transfers/${patientId}/${candidateId}/retry`, input).then(response => response.data);
export const PatientAutomationApi = {
 patientScope: () => Axios.get('/patients/automation/patient-scope').then(r=>r.data),
 savePatientScope: input => Axios.post('/patients/automation/patient-scope',input).then(r=>r.data),
 patientOptions: q => Axios.get('/patients/automation/patient-options',{params:{q}}).then(r=>r.data),
 schedule: () => Axios.get('/patients/automation/schedule').then(r=>r.data),
 saveSchedule: input => Axios.post('/patients/automation/schedule',input).then(r=>r.data),
 catalog: () => Axios.get('/patients/automation/catalog').then(r=>r.data),
 bcbas: () => Axios.get('/patients/automation-bcbas').then(r=>r.data),
 mappings: () => Axios.get('/patients/automation/mappings').then(r=>r.data),
 saveMapping: input => Axios.post('/patients/automation/mappings',input).then(r=>r.data),
 list: params => Axios.get('/patients/automation', {params}).then(r=>r.data),
 detail: id => Axios.get('/patients/automation/'+id).then(r=>r.data),
 controls: () => Axios.get('/patients/automation/controls').then(r=>r.data),
 setControl: input => Axios.post('/patients/automation/controls',input).then(r=>r.data),
 correct: (id,input) => Axios.post('/patients/automation/'+id+'/corrections',input).then(r=>r.data),
 retry: RecheckPatientTransfer,
};
